<template>
    <div>
        <modal :title="$t(title)" :visible.sync="isShowDialog" width="80%">
            <div class="dataPointPage">
                <v-search
                    :formContent="formContent"
                    :SearchForm="SearchForm"
                    :inline="true"
                    :optareBtn="optareBtn"
                    @autographFn="autographFn"
                    @resetFn="resetFn"
                    @confirmFn="getListFn"
                    @searchFn="getListFn"
                />
                <!-- 表格 -->
                <el-table
                    stripe
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :header-cell-style="headCellStyle"
                    :max-height="tableHeight"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="createTime" :label="$t('integration.record_point')" show-overflow-tooltip>
                        <template #default="{ row }">
                            <span>{{ optareFn($timetransition(row.createTime)) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="temp" :label="$t('integration.temperature') + unit['temp'].name" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-tooltip class="item" effect="dark" :content="TipFn(row, 'temp', unit['temp'].name)" placement="top">
                                <span>{{ row['temp'] }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="humidity" :label="$t('integration.humidity') + unit['hum'].name" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-tooltip class="item" effect="dark" :content="TipFn(row, 'humidity', unit['hum'].name)" placement="top">
                                <span>{{ row['humidity'] }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="recordUser" :label="$t('integration.person_in_charge')" show-overflow-tooltip />
                    <el-table-column :label="$t('integration.acquisition_time')" show-overflow-tooltip>
                        <template #default="{ row }">
                            {{ row.tempTime ? $timetransition(row.tempTime) : row.humidityTime ? $timetransition(row.humidityTime) : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" :label="$t('integration.record_time')" show-overflow-tooltip>
                        <template #default="{ row }">
                            <span>{{ $timetransition(row.createTime) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Operate" :label="$t('public.table_operation')" width="80px" align="right">
                        <template #default="{ row }">
                            <el-button type="text" size="small" icon="el-icon-news" :title="$t('integration.autograph')" @click="autographFnOne(row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            </div>
        </modal>
        <autoDialog :Atitle="Atitle" v-show="isShow" :isShow.sync="isShow" :choozeArray="choozeArray" :optareStatus="optareStatus" :rowPointId="rowPointId" :pointStr="pointStr" />
    </div>
</template>

<script>
import autoDialog from './AutographDia.vue';
import { carrierRecordPage } from '@/api/modules/record.js';

export default {
    props: ['title', 'isPointShow', 'pointId'],
    watch: {
        isPointShow(bool) {
            if (bool) {
                this.getListFn();
            }
        }
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isPointShow;
            },
            set: function(val) {
                this.$emit('update:isPointShow', val);
            }
        }
    },
    components: {
        autoDialog
    },
    data() {
        return {
            formContent: [
                {
                    id: 1,
                    text: $t('integration.record_point'),
                    type: 'times',
                    paramsName: 'recordStartTime',
                    paramsName2: 'recordEndTime',
                    isChooze: true
                },
                {
                    id: 2,
                    text: $t('integration.record_time'),
                    type: 'datetimerange',
                    paramsName: 'datetime',
                    isChooze: false
                },
                {
                    id: 3,
                    text: $t('integration.person_in_charge'),
                    type: 'input',
                    paramsName: 'recordUser',
                    isChooze: false
                }
            ],
            SearchForm: {
                time: null,
                datetime: null,
                startRecord: 0,
                maxRecords: 15,
                pointId: null,
                recordStartTime: null,
                recordEndTime: null,
                recordStartDateTime: null,
                recordEndDateTime: null,
                recordUser: null
            },
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    text: $t('integration.autograph'),
                    method: 'autographFn'
                }
            ],
            tableHeight: '400px',
            // 签名
            isShow: false,
            Atitle: '',
            tableData: [],
            choozeArray: [],
            // 数据点分页
            optareStatus: '',
            rowPointId: '',
            pointStr: ''
        };
    },
    methods: {
        getListFn() {
            this.SearchForm.pointId = this.pointId;

            let param = {};
            for (let key in this.SearchForm) {
                param[key] = this.SearchForm[key];
            }
            if (this.SearchForm.datetime) {
                param['recordStartDateTime'] = this.$dateParseTime(this.SearchForm.datetime[0]);
                param['recordEndDateTime'] = this.$dateParseTime(this.SearchForm.datetime[1]);
            }
            delete param.datetime;
            carrierRecordPage(param).then(({ result }) => {
                this.tableData = result;
            });
        },
        resetFn() {
            this.SearchForm = {
                time: null,
                datetime: null,
                startRecord: 0,
                maxRecords: 15,
                pointId: null,
                recordStartTime: null,
                recordEndTime: null,
                recordStartDateTime: null,
                recordEndDateTime: null,
                recordUser: null
            };
            this.getListFn();
        },
        autographFn() {
            if (this.choozeArray.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            this.isShow = true;
            this.optareStatus = 'more';
            this.Atitle = $t('integration.autograph');
        },
        autographFnOne(row) {
            this.isShow = true;
            this.optareStatus = 'one';
            this.Atitle = `[${this.$timetransition(row.createTime).split(' ')[1]}]签名`;
            this.rowPointId = row.id;
        },
        optareFn(time) {
            return time.split(' ')[1];
        },
        TipFn(row, str, unit) {
            return `[${row.tempTag}]-[${row[str]}${unit}]+[${this.$timetransition(row.updateTime)}]`;
        },
        handleSelectionChange(row) {
            this.choozeArray = row;
            this.pointStr = row.map(item => this.optareFn(this.$timetransition(item.createTime))).join(',');
        }
    }
};
</script>

<style></style>
